
import { Prop } from 'vue-property-decorator'
import { Vue } from 'vue-class-component'
import { setLocalStorage } from '@/helpers/cacheStorage'
import { KeyCache } from '@/model/key-cache.model'
import { useStore } from '@/store'
import { MyCouponInfoPayload } from '@/interfaces/store/myCouponInfo'
import * as meService from '@/services/line-web-loyalty-bff/v1/me'
import { alertMessageOptionsSomethingWentWrong } from '@/model/alert-options.model'

export default class ModalBottomGoldOnboard extends Vue {
  @Prop() onClose!: () => void

  store = useStore()
  isUpgrading = false

  async upgradeCustomerTier() {
    this.isUpgrading = true
    this.store.commit('modalEditProfile/updateIsLoadingSpinner', true)
    try {
      const token = this.store.state.lineInfo.idToken
      if (token) {
        const result = await meService.upgradeCustomerTier(token)
        const statusCode = result?.json?.code
        if (statusCode === 200) {
          await this.store.dispatch('tier/fetchTier', { token })
          await this.store.dispatch('myCouponInfo/reloadAllCoupons', { token } as MyCouponInfoPayload)
          this.closeModal()
        } else {
          this.onUpgradeError()
        }
      }
    } catch {
      this.onUpgradeError()
    } finally {
      this.isUpgrading = false
      this.store.commit('modalEditProfile/updateIsLoadingSpinner', false)
    }
  }

  onUpgradeError() {
    this.store.dispatch('alertMessage/onOpen', alertMessageOptionsSomethingWentWrong)
    setTimeout(() => this.store.dispatch('alertMessage/onClose'), 3000)
    // close modal without caching dismissal so it shows again on next visit/refresh
    this.dismissModal()
  }

  closeModal() {
    setLocalStorage(KeyCache.IS_DISMISSED_UPGRADE_TIER, true)
    this.dismissModal()
  }

  dismissModal() {
    if (this.onClose) {
      setTimeout(() => {
        this.onClose()
      }, 300)
    }
  }
}
